<template>
    <app-content-admin>
        <template slot="header">Edit Template</template>

        <v-layout row wrap>
            <v-flex xs12 lg6 mx-auto>
                <v-card>
                    <v-card-text>
                        <v-container fluid grid-list-xs>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-select
                                        :items="project_list"
                                        :item-text="'project_name'"
                                        :item-value="'project_id'"
                                        :label="$t('Project')"
                                        v-model="form.id_project"
                                        :rules="[rules.required('Project')]"
                                        outlined
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field
                                        :label="$t('Template Title')"
                                        v-model="form.template_title"
                                        :rules="[
                                            rules.required('Template Title'),
                                        ]"
                                        outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                   <div class="textarea-wrap">
                                        <v-textarea
                                            :label="$t('Template Description')"
                                            v-model="form.template_description"
                                            outlined
                                            maxlength="60" 
  
                                        >
                                        </v-textarea>
                                       <span class="message-counter">{{ form.template_description.length }} / 60</span>
                                    </div>
                                </v-flex>
                                <v-flex xs12>
                                    <v-select
                                        label="Notifcation Type"
                                        outlined
                                        :items="[
                                            'lastest_new',
                                            'event',
                                            'voucher',
                                            'promotion',
                                            'order',
                                            'tool',
                                        ]"
                                        v-model="form.notification_type"
                                    ></v-select>
                                </v-flex>
                                <!-- <v-flex xs12>
                                    <v-file-input
                                        label="File input"
                                        outlined
                                        variant="outlined"
                                        
                                        v-model="file"
                                        @change="handleFileChange"
                                    ></v-file-input>
                                </v-flex> -->
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="updateProject"
                            class="form-submit"
                           
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            project_list: [],
            form: {
                id_project: null,
                id_template: 0,
                template_title: null,
                template_description: '',
                notification_type: null,
                file_upload:null,
            },
            file: null,
            type:null,
            fileContent: ''
        };
    },

    components: { ActiveLabel },

    created() {
        let loader = this.$loading.show();

        let token = store.getters["auth/token"];
        axios
            .get(`/api/cloud/get_firebase_project_list?token=${token}`)
            .then((res) => res.data)
            .then((res) => {
                this.project_list = res.data.result.map((item) => {
                    return {
                        project_id: item.id_project,
                        project_name: item.firebase_project_name,
                    };
                });
            })
            .catch((err) => {
                this.$toastr.e(err.response.data.message);
            })
            .finally(() => {
                loader.hide();
            });

        
            this.form.id_template = this.$route.params.id;
            console.log(this.form.id_template)
            this.getFirebaseTemplate();
            
      
    },

   

    methods: {
        

        async updateProject() {
            let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/update_firebase_template?token=${token}`,
                    this.form
                );

                if (res.data.status == "success") {
                    this.$toastr.s(res.data.data.result);
                }
            } catch (err) {
                this.$toastr.e(err.response.data.message);
            } finally {
                loader.hide();
            }
        },

        async getFirebaseTemplate() {
            let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.get(
                    `/api/cloud/get_firebase_template?token=${token}`
                   , {params:{id_template:this.form.id_template}}
                );

                 if(res.data.status == "success"){
                    this.form.id_project = res.data.data.result.id_project;
                    this.form.template_description = res.data.data.result.template_description;
                    this.form.template_title = res.data.data.result.template_title;
                    this.form.file_upload = res.data.data.result.image_url;
                    const filename = this.filenameToFile(this.form.file_upload);
                    console.log(filename);
                    this.file = filename;
                    this.form.notification_type = res.data.data.result.notification_type;
                    console.log(res.data.data.result)
                    
                 }
            } catch (err) {
                this.$toastr.e(err.response.data.message);
            } finally {
                loader.hide();
            }
        },

       filenameToFile(filename) {
          const blob = new Blob([], { type: 'application/octet-stream' });
          blob.lastModifiedDate = new Date();
          blob.name = filename;
          // Create a File object from the blob
          const file = new File([blob], filename);
          return file;
        },
    

         async uploadFile() {
              const formData = new FormData();
              formData.append("file", this.file);
           let loader = this.$loading.show();
            try {
                let token = store.getters["auth/token"];
                let res = await axios.post(
                    `/api/cloud/upload_image?token=${token}`,formData, {
                        headers: {
                          'Content-Type': 'multipart/form-data'
                        }
                    });

                if (res.data.status == "success") {

                    
                    this.$toastr.s('Upload image Success!');
                    this.form.file_upload = res.data.data.fileName;
                  
                }
            } catch (err) {
                this.$toastr.e('Upload image fail!');
            } finally {
                loader.hide();
            }
        },

        handleFileChange(file) {
            this.file = file;
            this.uploadFile();
        },

        fileChange(e) {
            this.form.firebase_service_account = e.name;
        },
    },
};
</script>

<style>
.textarea-wrap {
  position: relative;
  max-width: 100%;
  margin: auto;
}

.message-counter {
  position: absolute;
  right: 5px;
  bottom: 36px;
  font-size: 13px;
  color: black;
}

</style>
